import React, { useState } from "react";
import { useContext } from "react";
import { MdBackspace } from "react-icons/md";
import { ImBlocked } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import ListGroup from "react-bootstrap/ListGroup";
import Avatar from "react-avatar";
import { Card, Col, Row } from "react-bootstrap";
import { formatDate } from "../utils/utils";
import Button from "react-bootstrap/Button";
import Loading from "./Loading";
import { UsersContext } from "../context/UsersContext";
import OperationsModal from "../components/users/OperationsModal";
import useIsLargeScreen from "../utils/useIsLargeScreen";
import SideBar from "../components/menu/SideBar";
import BackBtn from "../components/menu/BackBtn";

const Users = () => {
  const isLargeScreen = useIsLargeScreen();
  const [modalOperationsShow, setModalOperationsShow] = useState(false);

  const handleClose = () => setModalOperationsShow(false);
  const handleShow = () => setModalOperationsShow(true);
  const navigate = useNavigate();
  const backToMap = () => {
    navigate("/map");
  };

  const {
    // allUsers,
    // getAllUsers,
    // setUserInfo,
    userRole,
    loading,
    // userInfo,
    // loggedUserInfo: { pic },
  } = useContext(AuthContext);

  const {
    setUserInfo,
    userInfo,
    getAllUsers,
    allUsers,
    loggedUserInfo: { pic },
    loading: userLoading,
  } = useContext(UsersContext);

  // useEffect(() => {
  //   getAllUsers();
  // }, [userInfo.status, userInfo.role]);
  useEffect(() => {
    getAllUsers();
  }, [userInfo]);

  return (
    <div className='d-flex flex-row blue-background pb-5'>
      {isLargeScreen && <SideBar />}
      <section className='w-100 section-full-page section-users section-large page-large-container min-100'>
        <BackBtn />
        <section className='section-center'>
          <h2 className='section-title pt-5'>Lista Utenti</h2>
          <div className='d-md-flex justify-content-md-center'>
            {loading && <Loading />}
            {userLoading && <Loading />}

            <Col md={6} className='justify-content-md-center'>
              <ListGroup>
                {allUsers &&
                  allUsers.map((i) => {
                    const {
                      id,
                      first_name,
                      last_name,
                      birthday,
                      city,
                      user_name,
                      role,
                      createdAt,
                      status,
                      pic,
                    } = i;

                    return (
                      <ListGroup.Item className='mt-2 p-0'>
                        <div className='d-flex'>
                          {/* <Avatar facebookId='100008343750912' size='100' /> */}
                          <Avatar
                            src={pic}
                            maxInitials={2}
                            // className='direct-chat-img'
                            name={user_name}
                          />

                          <div className='d-flex flex-column justify-content-center ps-4'>
                            <span>
                              {" "}
                              Nome: {user_name} {status === 1 && <ImBlocked />}
                            </span>
                            <span> Ruolo: {role}</span>
                            <span>Registrato: {formatDate(createdAt)}</span>
                            {userRole === "admin" && (
                              <Card.Link
                                className='copy'
                                variant='primary'
                                onClick={() => {
                                  handleShow(true);
                                  setUserInfo({
                                    id,
                                    role,
                                    status,
                                  });
                                }}
                              >
                                Modifica
                              </Card.Link>
                            )}
                            {/* <Button
                                onClick={() => setModalOperationsShow(true)}
                                variant='link'
                              >
                                Link
                              </Button> */}
                          </div>
                        </div>
                      </ListGroup.Item>
                    );
                  })}
              </ListGroup>
            </Col>
          </div>
        </section>

        <OperationsModal
          handleClose={handleClose}
          show={modalOperationsShow}
          onHide={() => handleClose()}
        />
      </section>
    </div>
  );
};

export default Users;

// function MyVerticallyCenteredModal(props) {
//   return (
//     <Modal
//       {...props}
//       size='lg'
//       aria-labelledby='contained-modal-title-vcenter'
//       centered
//     >
//       <Modal.Header closeButton>
//         <Modal.Title id='contained-modal-title-vcenter'>
//           Modal heading
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <h4>Centered Modal</h4>
//         <p>
//           Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
//           dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
//           consectetur ac, vestibulum at eros.
//         </p>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button onClick={props.onHide}>Close</Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

// function App() {
//   const [modalShow, setModalShow] = React.useState(false);

//   return (
//     <>
//       <Button variant='primary' onClick={() => setModalShow(true)}>
//         Launch vertically centered modal
//       </Button>

//       <MyVerticallyCenteredModal
//         show={modalShow}
//         onHide={() => setModalShow(false)}
//       />
//     </>
//   );
// }

// render(<App />);
